import { XCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CardWithdrawAmountProps {
    value: number;
    onChange: (value: number) => void;
    maxAmount?: number;
    quickAmounts?: number[];
    className?: string;
}

const formatRupiah = (amount: number) => new Intl.NumberFormat('id-ID').format(amount)

const parseAmount = (raw: string) => {
    const digits = raw.replace(/\D/g, '')
    return digits ? Number(digits) : 0
}

const quickButtonClass = (isSelected: boolean) =>
    cn(
        'rounded-[8px] py-3 px-4 title2medium border transition-all disabled:opacity-50',
        isSelected
            ? 'border-text-blue-100 bg-text-blue-10 text-text-blue-100'
            : 'border-transparent bg-bg-grey-100 text-black'
    )

const CardWithdrawAmount = ({
    value,
    onChange,
    maxAmount = 0,
    quickAmounts = [50000, 100000, 200000],
    className,
}: CardWithdrawAmountProps) => {
    const isAll = maxAmount > 0 && value === maxAmount

    return (
        <article className={cn('shadowCard w-full p-3 flex flex-col gap-3', className)}>
            <h3 className='title2medium'>Nominal Penarikan</h3>

            <div className="relative w-full">
                <span className='h5bold absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none select-none text-black'>
                    Rp
                </span>
                <input
                    type='text'
                    inputMode='numeric'
                    autoComplete='off'
                    aria-label='Nominal penarikan'
                    value={value ? formatRupiah(value) : ''}
                    placeholder='0'
                    onChange={(e) => onChange(parseAmount(e.target.value))}
                    className='text-[24px]! font-bold! h-[54px]! w-full pl-14! pr-12! py-0! bg-text-blue-10 border-0! rounded-[8px]! text-black! focus:outline-2 focus:outline-text-blue-100 placeholder:text-text-grey'
                />
                {value > 0 && (
                    <button
                        type='button'
                        aria-label='Hapus nominal'
                        onClick={() => onChange(0)}
                        className='absolute right-4 top-1/2 -translate-y-1/2 z-10 flex h-6 w-6 items-center justify-center text-text-grey'
                    >
                        <XCircle size={20} />
                    </button>
                )}
            </div>

            <h3 className='title2medium'>Pilihan Cepat</h3>
            <div className="grid grid-cols-2 gap-3">
                {quickAmounts.map((amount) => (
                    <button
                        key={amount}
                        type='button'
                        onClick={() => onChange(amount)}
                        className={quickButtonClass(value === amount && !isAll)}
                    >
                        Rp {formatRupiah(amount)}
                    </button>
                ))}
                <button
                    type='button'
                    disabled={maxAmount <= 0}
                    onClick={() => onChange(maxAmount)}
                    className={quickButtonClass(isAll)}
                >
                    Tarik Semua
                </button>
            </div>
        </article>
    )
}

export default CardWithdrawAmount
